import { render, staticRenderFns } from "./myClass.vue?vue&type=template&id=08b9f035&"
import script from "./myClass.vue?vue&type=script&lang=js&"
export * from "./myClass.vue?vue&type=script&lang=js&"
import style0 from "./myClass.vue?vue&type=style&index=0&id=08b9f035&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports